import React from 'react';
import styled from "styled-components";
import {QRCodeSVG} from 'qrcode.react';
import {v4 as uuid} from 'uuid';

const PrintCodesScreen = (props) => {
  const params = props.location.search
    .slice(1)
    .split('&')
    .reduce((obj, v) => {
      obj[v.split('=')[0]] = decodeURIComponent(v.split('=')[1])
      return obj;
    }, {});

  let row = -1;
  let codes = [];
  for (let i = 0; i < params.number; i++) {
    if (i % params.perRow === 0) {
      row += 1;
      codes[row] = [];
    }
    switch(params.type) {
      case "INCREMENT":
        codes[row].push(`${params.prefix}${parseInt(params.initial) + parseInt(i)}`);
        break;
      case "STATIC":
        codes[row].push(params.static);
        break
      case "UUID":
      default:
        codes[row].push(uuid());
        break;
    }
  }
  return (
    <Table>
      <tbody>
      { codes.map(row => (
        <tr>
          { row.map(code => (
            <td>
              <QRCodeSVG value={code} size={params.scale * 128} />
              <p>{code}</p>
              <p>{params.description}</p>
            </td>
          ))}
        </tr>
      ))}
      </tbody>
    </Table>
  )
}

const Table = styled.table`
  width: 100%;

  td {
    text-align: center;
    padding: 1.9375rem
  }
`

export default PrintCodesScreen